<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
<toaster-container></toaster-container>
<footer class="bg-light text-center text-lg-start">
    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
        © 2021 Development by Cristhian Jumbo:
        <a class="text-blue" href="https://crisweb.me/">Visit my porfolio crisweb.com</a>
    </div>
    <!-- Copyright -->
</footer>
